//   $('.playbtnprnt').click(function(event) {
//    var sctionId=$(this).attr('sctionId')
//   var video = $('#'+sctionId)[0];
//   if (video.paused) {
//     video.play();
//     $('.playbtnprnt').hide();
//   }
//   else {
//     video.pause();
//   }
//   return false;
// });

  if($('.custom-checkoutbtun').length){
    var getbtn=$('.custom-checkoutbtun').attr('btntxt');
setInterval(function(){
  // if($('.shopify-payment-button__button').hasClass('actOrder')){}else{
  $('.shopify-payment-button__button').text(getbtn);
  // $('.shopify-payment-button__button').addClass('actOrder');
  // }
},100)
// settimeout(function(){
//    $('.shopify-payment-button__button').text('Pre-Order Now');
// },3000)
// settimeout(function(){
//    $('.shopify-payment-button__button').text('Pre-Order Now');
// },2000)
}

if($(window).width() < 768) {
  setTimeout(() => {
    var content = $('.sticky-item input[type="radio"]:checked').parent().html();
    $('.sticky-active_variant').append(content);
  }, 500);
}

$('.product-options--root .radios--main').click(function() {
  var index = $(this).index() + 1;
  $(".sticky-item:nth-child(" + index + ") input").prop('checked', true);
  var image = $('.variant-image:nth-child(' + index + ')').attr('data-image');
  $('.sticky-image img').attr('srcset', image);
  var content = $('.sticky-item input[type="radio"]:checked').parent().html();
  $('.sticky-active_variant').empty();
  $('.sticky-active_variant').append(content);
});
$('.sticky-item').click(function() {
  var index = $(this).index() + 1;
  $('.product-options--root .radios--main:nth-child(' + index + ') input').click();
  var content = $('.sticky-item input[type="radio"]:checked').parent().html();
  $('.sticky-active_variant').empty();
  $('.sticky-active_variant').append(content);
});
$('.sticky-btn').click(function() {
  $('.product-page--right-column .product-buy-buttons--cta').click();
});

function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if( elem.length == 0 ) {
		return;
	}
	var $window = jQuery(window)
	var viewport_top = $window.scrollTop() - 500
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height
	var $elem = jQuery(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

jQuery( document ).ready( function() {
  	window.addEventListener('scroll', function(e) {
		if( isOnScreen( jQuery( '.layout--main-content > .shopify-section:nth-child(2)' ) ) || isOnScreen( jQuery( '.layout--main-content > .shopify-section:nth-child(3)' ) ) || isOnScreen( jQuery( '.layout--main-content > .shopify-section:nth-child(4)' ) ) || isOnScreen( jQuery( '.layout--main-content > .shopify-section:nth-child(5)' ) )  ) { /* Pass element id/class you want to check */
			$('.sticky-atc').addClass('sticky');
            if($(window).width() > 768) {
              $('header-root').addClass('sticky');
            }
 		}	
        else {
          $('.sticky-atc').removeClass('sticky');
          if($(window).width() > 768) {
          $('header-root').removeClass('sticky');
          }
        }
	});
});

$('.sticky-arrow').click(function() {
  if($(this).hasClass('active')) {
    $(this).removeClass('active');
  }
  else {
    $(this).addClass('active');
  }
  if($('.sticky-left').hasClass('active')) {
    $('.sticky-left').removeClass('active');
  }
  else {
    $('.sticky-left').addClass('active');
  }
});
$('.custom-slider_section').slick({
  infinite: false,
  slidesToShow: 2,
  slidesToScroll: 2,
  dots: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
});